<template>
    <div>
        <template v-if="adminMode">
            <div class="card-header py-3">
                <strong>{{ lang.app.subscription.package_subscription_payment_screen.admin_mode_title }}</strong>
                <small>(User: {{user.email}})</small>
            </div>
            <div v-if="paymentUrl" class="card-body">
                <h6>{{ lang.app.subscription.package_subscription_payment_screen.admin_mode_line1 }}</h6>
            </div>
        </template>
        <template v-else>
            <div class="card-header py-3">
                <small><strong>{{ lang.app.subscription.package_subscription_payment_screen.title }}</strong></small>
            </div>
            <div v-if="paymentUrl" class="card-body">
                <h6>{{ lang.app.subscription.package_subscription_payment_screen.line1 }}</h6>
                <template v-if="paymentUrl">
                    <h6 class="mt-4"><strong>{{ lang.app.subscription.package_subscription_payment_screen.bold_line1 }}</strong></h6>
                    <h6 class="mt-2">{{ lang.app.subscription.package_subscription_payment_screen.line2 }}</h6>

                    <div class="mt-4">
                        <h6 class="mb-2">
                            {{ lang.app.subscription.package_subscription_payment_screen.vat_number_required }}
                        </h6>
                        <div class="form-group row">
                            <label for="vat_number"
                                   class="col-md-3 col-form-label">
                                {{ lang.app.profile.btw_kvk_vat_number }}
                            </label>
                            <div class="col-md-6 pl-0">
                                <input id="vat_number"
                                       type="text"
                                       class="form-control"
                                       name="vat_number"
                                       v-model="vatNumber"
                                       required
                                       maxlength="14"
                                       autocomplete="off"
                                       :placeholder="(country ? lang.app.profile['btw_example_' + country.toLowerCase()] : lang.app.profile.btw_kvk_vat_number)"
                                >
                                <error-ele v-if="formValidationErrors && formValidationErrors[user.role + '.vat_number']"
                                           :errors="formValidationErrors[user.role + '.vat_number']"/>
                            </div>
                        </div>

                        <input type="hidden" name="country" :value="country">

                        <button-loader :isLoading="buttonLoader"
                                       :disabled="buttonLoader || !vatNumber || !(vatNumber.trim().length)"
                                       class="btn px-md-4 mt-4"
                                       style="background-color: #00DC95; color: white;"
                                       @click="submitForm"
                        > {{ paymentAmount <= 0 ? lang.app.subscription.package_subscription_payment_screen.goto_farmdesk : lang.app.subscription.package_subscription_payment_screen.payment_btn_title }}
                        </button-loader>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "PackageSubscriptionPaymentScreen",
        props: ["adminMode", "paymentUrl", "paymentAmount", "user"],
        data() {
            let country = this.user.address ? this.user.address.country : '';
            let vatNumber = '';
            if (this.user.role === 'farmer') {
                vatNumber = this.user.farmer.vat_number || '';
            } else if (this.user.role === 'advisor') {
                vatNumber = this.user.advisor.vat_number || '';
            }
            return {
                buttonLoader: false,
                country: country,
                vatNumber: vatNumber,
                originalVatNumber: vatNumber.trim()
            }
        },
        methods: {
            getUserForm() {
                let form = {
                    user_api_id: this.user.id,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    role: this.user.role,
                    telephone: this.user.telephone,
                    email: this.user.email,
                    address: this.user.address ? this.user.address : {
                        city: "",
                        country: "",
                        street_name: "",
                        street_number: "",
                        postal_code: "",
                    },
                    is_profile_completed: true,
                    product: this.product,
                };

                if (this.user.role === 'farmer') {
                    form.farmer = {
                        vat_number: this.user.farmer.vat_number || "",
                        company_name: this.user.farmer.company_name || "",
                        ubn_number: this.user.farmer.ubn_number || "",
                        exploitation_number: this.user.farmer.exploitation_number || "",
                        is_professional: this.user.farmer.is_professional || false,
                        bio_certified: this.user.farmer.bio_certified,
                    }
                }

                else if (this.user.role === 'advisor') {
                    form.advisor = {
                        vat_number: this.user.advisor.vat_number || "",
                    }
                }

                return form;
            },

            submitForm() {
                this.buttonLoader = true;
                if (!this.originalVatNumber || (this.originalVatNumber !== this.vatNumber.trim())) {
                    const form = this.getUserForm();
                    if (this.user.role === 'farmer') {
                        form.farmer.vat_number = this.vatNumber.trim();
                    } else {
                        form.advisor.vat_number = this.vatNumber.trim();
                    }
                    return api.profile
                        .postUpdate(form)
                        .then(response => {
                            this.formError = null;
                            window.location.href = this.paymentUrl;
                        })
                        .catch(error => {
                            if (error.response.status === 422) {
                                if (error.response && error.response.data) {
                                    this.formError = error.response.data;
                                }
                            }
                            this.buttonLoader = false;
                        });
                } else {
                    window.location.href = this.paymentUrl;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/subscription/PackageSubscriptionPaymentScreen.vue